import { gql } from "@apollo/client";
const GET_PREFERENCE = gql`
  query {
    getPreference {
      ... on GetPreferenceResponse {
        id
      }
      ... on ResultError {
        status_code
        message
      }
    }
  }
`;
export { GET_PREFERENCE };
